import { getBusinessMergeFields } from 'components/WYSIWYG/use-merge-fields';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getChosenBusiness } from 'store/authentication/selectors';

export const useHomepageMergeFields = () => {
  const { t } = useTranslation();
  const chosenBusiness = useSelector(getChosenBusiness);

  return useMemo(() => {
    return [
      {
        label: t('Team Member Fields'),
        items: [
          {
            label: t('Team Member First Name'),
            relationship: 'team_member.first_name',
          },
          {
            label: t('Team Member Last Name'),
            relationship: 'team_member.last_name',
          },
          {
            label: t('Team Member Email'),
            relationship: 'team_member.email',
          },
          {
            label: t('Team Member Phone'),
            relationship: 'team_member.phone',
          },
          {
            label: t('Active Role(s)'),
            relationship: 'team_member.roles',
          },
        ],
      },
      {
        label: t('Business Fields'),
        items: getBusinessMergeFields(t, chosenBusiness.business_variables),
      },
      {
        label: t('Default Fields'),
        items: [
          {
            label: t("Today's Date"),
            relationship: 'team_member.date',
          },
          {
            label: t('Current Time (User Timezone)'),
            relationship: 'team_member.time',
          },
          {
            label: t('Current Time (Business Timezone)'),
            relationship: 'business.time',
          },
        ],
      },
    ];
  }, [t, chosenBusiness.business_variables]);
};
